// extracted by mini-css-extract-plugin
export var heading = "index-module--heading--3d1c9";
export var headingContainer = "index-module--heading-container--255e6";
export var highlight = "index-module--highlight--31ced";
export var highlightLine = "index-module--highlight-line--45779";
export var image1 = "index-module--image-1--af4cc";
export var image2 = "index-module--image-2--bd15a";
export var imageContainer = "index-module--image-container--6986e";